export default __webpack_public_path__ + "static/nicole1-e751cac280c381b1768a3478a5e071af.png";